import React from 'react';
import { Person } from '@mui/icons-material';
import { DragAndDropHandlers } from '../hooks/useDragAndDrop';

export interface AssigneeGroupHeaderProps {
  assignee: string;
  workItemCount: number;
  currentUser?: string;
  isDragOverAssignee: boolean;
  dragHandlers: DragAndDropHandlers;
}

export const AssigneeGroupHeader: React.FC<AssigneeGroupHeaderProps> = ({
  assignee,
  workItemCount,
  currentUser,
  isDragOverAssignee,
  dragHandlers
}) => {
  const isCurrentUser = currentUser && assignee.includes(currentUser.split(' ')[0]);
  
  const headerClasses = [
    'assignee-group-header',
    isCurrentUser ? 'current-user' : '',
    isDragOverAssignee ? 'drag-over-assignee' : ''
  ].filter(Boolean).join(' ');

  return (
    <div
      className={headerClasses}
      onDragOver={(e) => dragHandlers.handleAssigneeGroupDragOver(e, assignee)}
      onDrop={(e) => dragHandlers.handleAssigneeGroupDrop(e, assignee)}
      onDragEnter={(e) => dragHandlers.handleAssigneeGroupDragEnter(e, assignee)}
      onDragLeave={dragHandlers.handleAssigneeGroupDragLeave}
    >
      <div className="assignee-info">
        <Person style={{ fontSize: '18px', marginRight: '8px' }} />
        <span className="assignee-name">{assignee}</span>
        {isCurrentUser && <span className="current-user-badge">(You)</span>}
      </div>
      <div className="workitem-count">
        {workItemCount} work item{workItemCount !== 1 ? 's' : ''}
      </div>
    </div>
  );
};